<template>
  <div id="claim-summary">
    <div class="content-between">
      <common-text-medium class="mb-8" text="事故概要" />
      <common-claim-report-card ref="PolicyHolderEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">
              保険契約者名<span class="required ml-2">*</span>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(policyHolder.updated_at)"
              :createdAt="getDateTime(policyHolder.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ policyHolder.input_values }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-text-box-small ref="PolicyHolder" />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'PolicyHolderEdit',
                    $refs.PolicyHolder.inputValue,
                    policyHolder
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('PolicyHolderEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>

      <div class="p-4">
        <div class="flex items-start justify-between">
          <div class="title">船舶名<span class="required ml-2">*</span></div>
          <common-updated-label
            :updatedAt="getDateTime(vesselId.updated_at)"
            :createdAt="getDateTime(vesselId.created_at)"
          />
        </div>

        <div>
          {{ vesselId.input_values }}
        </div>
      </div>
      <vs-divider class="m-0"></vs-divider>

      <common-claim-report-card ref="AccidentTypeEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">
              事故種類<span class="required ml-2">*</span>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(accidentType.updated_at)"
              :createdAt="getDateTime(accidentType.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ getAccidentType(accidentType.input_values) }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-select-box-small
                :required="false"
                ref="AccidentType"
                :options="accidents"
                :name="'AccidentType'"
                :showTitle="false"
              />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'AccidentTypeEdit',
                    $refs.AccidentType.inputValue.value,
                    accidentType
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('AccidentTypeEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>

      <common-claim-report-card ref="AccidentDateEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">事故日</div>
            <common-updated-label
              :updatedAt="getDateTime(accidentDate.updated_at)"
              :createdAt="getDateTime(accidentDate.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ setDateFormat(accidentDate.input_values, "YYYY/MM/DD") }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <text-box-date
                ref="AccidentDate"
                :maxDate="accidentDateMaxDate"
              ></text-box-date>
            </div>
            <div class="w-32 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'AccidentDateEdit',
                    setDateFormat($refs.AccidentDate.inputValue, 'YYYY-MM-DD'),
                    accidentDate
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('AccidentDateEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>

      <common-claim-report-card ref="AccidentTimeEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">時間</div>
            <common-updated-label
              :updatedAt="getDateTime(accidentTime.updated_at)"
              :createdAt="getDateTime(accidentTime.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ accidentTime.input_values }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <text-box-time
                ref="AccidentTime"
                :name="'AccidentTime'"
              ></text-box-time>
            </div>
            <div class="w-32 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'AccidentTimeEdit',
                    $refs.AccidentTime.inputValue,
                    accidentTime
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('AccidentTimeEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>

      <common-claim-report-card ref="AccidentPlaceEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">
              事故場所<span class="required ml-2">*</span>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(accidentPlace.updated_at)"
              :createdAt="getDateTime(accidentPlace.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ accidentPlace.input_values }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-text-box-small
                ref="AccidentPlace"
                :name="'AccidentPlace'"
              />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'AccidentPlaceEdit',
                    $refs.AccidentPlace.inputValue,
                    accidentPlace
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('AccidentPlaceEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>
      <common-claim-report-card ref="AccidentSummaryEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">
              事故概要<span class="required ml-2">*</span>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(accidentSummary.updated_at)"
              :createdAt="getDateTime(accidentSummary.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ accidentSummary.input_values }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-text-box-large
                ref="AccidentSummary"
                :name="'AccidentSummary'"
              />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'AccidentSummaryEdit',
                    $refs.AccidentSummary.inputValue,
                    accidentSummary
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('AccidentSummaryEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>
      <common-claim-report-card ref="DamageSituationEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">
              損害状況<span class="required ml-2">*</span>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(damageSituation.updated_at)"
              :createdAt="getDateTime(damageSituation.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ damageSituation.input_values }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-text-box-large ref="DamageSituation" />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'DamageSituationEdit',
                    $refs.DamageSituation.inputValue,
                    damageSituation
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('DamageSituationEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>
      <common-claim-report-card ref="SelfPropelledEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">
              自航可否<span class="required ml-2">*</span>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(selfPropelled.updated_at)"
              :createdAt="getDateTime(selfPropelled.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ getSelfPropelled(selfPropelled.input_values) }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-radio-button-box
                :options="selfPropelledList"
                ref="SelfProprlied"
              />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'SelfPropelledEdit',
                    $refs.SelfProprlied.inputValue,
                    selfPropelled
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('SelfPropelledEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>

      <div class="p-4">
        <div class="flex items-start justify-between">
          <div class="title">写真</div>
        </div>
        <common-file-list
          title="写真"
          :inputValue="pictures"
          :deleteFile="deleteFile"
          :onClickFileLink="
            (fileName, token) =>
              downloadFile(
                insurerEnterpriseId,
                ownerEnterpriseId,
                $route.params.id,
                pictures.id,
                fileName,
                token,
                true
              )
          "
          :onClickDownloadFile="
            (fileName, token) =>
              downloadFile(
                insurerEnterpriseId,
                ownerEnterpriseId,
                $route.params.id,
                pictures.id,
                fileName,
                token,
                false
              )
          "
          ref="Pictures"
        >
          <template v-slot:uploader>
            <div class="flex items-center">
              <div class="w-full mr-4">
                <common-input-file
                  title="写真"
                  ref="PicturesInput"
                ></common-input-file>
              </div>
              <div class="w-32 mb-4 mr-2">
                <vs-button
                  class="w-full"
                  size="small"
                  :color="AISEA_COLOR.BLUE"
                  @click.stop="
                    toggleSaveFiles(
                      'Pictures',
                      $refs.PicturesInput.files,
                      inputValue.overview.pictures
                    )
                  "
                  >保存</vs-button
                >
              </div>
            </div>
          </template>
        </common-file-list>
      </div>
      <vs-divider class="m-0"></vs-divider>
      <common-claim-report-card ref="FreeMessageEdit">
        <template v-slot:title>
          <div class="flex items-start justify-between">
            <div class="title">フリー項目</div>
            <common-updated-label
              :updatedAt="getDateTime(freeMessage.updated_at)"
              :createdAt="getDateTime(freeMessage.created_at)"
            />
          </div>
        </template>
        <template v-slot:contents>
          <div>
            {{ freeMessage.input_values }}
          </div>
        </template>
        <template v-slot:editing>
          <div class="flex items-center">
            <div class="w-full mr-4">
              <common-text-box-large title="フリー記入" ref="FreeMessage" />
            </div>
            <div class="w-32 mb-4 mr-2">
              <vs-button
                class="w-full"
                size="small"
                :color="AISEA_COLOR.BLUE"
                @click.stop="
                  toggleSave(
                    'FreeMessageEdit',
                    $refs.FreeMessage.inputValue,
                    freeMessage
                  )
                "
                >保存</vs-button
              >
            </div>
            <div class="w-48 mb-4">
              <vs-button
                size="small"
                type="border"
                :color="AISEA_COLOR.GRAY"
                @click.stop="toggleCancel('FreeMessageEdit')"
                >キャンセル</vs-button
              >
            </div>
          </div>
        </template>
      </common-claim-report-card>

      <div class="p-4">
        <div class="flex items-start justify-between">
          <div class="title">その他の添付ファイル</div>
        </div>

        <common-file-list
          title="その他の添付ファイル"
          :inputValue="freeFiles"
          :deleteFile="deleteFile"
          :onClickFileLink="
            (fileName, token) =>
              downloadFile(
                insurerEnterpriseId,
                ownerEnterpriseId,
                $route.params.id,
                freeFiles.id,
                fileName,
                token,
                true
              )
          "
          :onClickDownloadFile="
            (fileName) =>
              downloadFile(
                insurerEnterpriseId,
                ownerEnterpriseId,
                $route.params.id,
                freeFiles.id,
                fileName,
                token,
                false
              )
          "
          ref="FreeFiles"
        >
          <template v-slot:uploader>
            <div class="flex items-center">
              <div class="w-full mr-4">
                <common-input-file
                  title="その他の添付ファイル"
                  ref="FreeFilesInput"
                ></common-input-file>
              </div>
              <div class="w-32 mb-4 mr-2">
                <vs-button
                  class="w-full"
                  size="small"
                  :color="AISEA_COLOR.BLUE"
                  @click.stop="
                    toggleSaveFiles(
                      'FreeFiles',
                      $refs.FreeFilesInput.files,
                      inputValue.overview.free_files
                    )
                  "
                  >保存</vs-button
                >
              </div>
            </div>
          </template>
        </common-file-list>
      </div>
      <vs-divider class="m-0"></vs-divider>

      <common-text-medium class="my-8" text="事故登録情報" />

      <!-- 損害担当者の時表示 -->
      <div v-show="isInsuranceCompany">
        <!-- 整理番号 -->
        <common-claim-report-card ref="ReferenceNoEdit">
          <template v-slot:title>
            <div class="flex items-start justify-between">
              <div class="title">整理番号</div>
              <common-updated-label
                :updatedAt="getDateTime(referenceNo.updated_at)"
                :createdAt="getDateTime(referenceNo.created_at)"
              />
            </div>
          </template>
          <template v-slot:contents>
            <div>
              {{ accidentRegistInfoText(referenceNo.input_values) }}
            </div>
          </template>
          <template v-slot:editing>
            <div class="flex items-center">
              <div class="w-full mr-4">
                <common-text-box-small
                  :required="false"
                  ref="ReferenceNo"
                  :showTitle="false"
                />
              </div>
              <div class="w-32 mb-4 mr-2">
                <vs-button
                  class="w-full"
                  size="small"
                  :color="AISEA_COLOR.BLUE"
                  @click.stop="
                    toggleSave(
                      'ReferenceNoEdit',
                      $refs.ReferenceNo.inputValue,
                      inputValue.overview.reference_no
                    )
                  "
                  >保存</vs-button
                >
              </div>
              <div class="w-48 mb-4">
                <vs-button
                  size="small"
                  type="border"
                  :color="AISEA_COLOR.GRAY"
                  @click.stop="toggleCancel('ReferenceNoEdit')"
                  >キャンセル</vs-button
                >
              </div>
            </div>
          </template>
        </common-claim-report-card>

        <!-- 事件番号1 -->
        <common-claim-report-card ref="IssueNoandInsuranceKindEdit1">
          <template v-slot:contents>
            <div class="flex items-start justify-between">
              <div class="flex items-start">
                <div class="mr-8">
                  <div class="title">事件番号</div>
                  <div>
                    {{ getIssueNo(issueNo1.input_values) }}
                  </div>
                </div>
                <div>
                  <div class="title">保険種類</div>
                  <div>
                    {{ getInsuranceKind(issueNo1.input_values) }}
                  </div>
                </div>
              </div>
              <common-updated-label
                :updatedAt="getDateTime(issueNo1.updated_at)"
                :createdAt="getDateTime(issueNo1.created_at)"
              />
            </div>
          </template>

          <template v-slot:editing>
            <div>
              <div class="flex items-center"></div>
            </div>
            <div>
              <div class="flex items-start justify-between">
                <div class="flex items-start">
                  <div class="mr-8">
                    <div class="title">事件番号</div>
                    <div class="w-48 mr-4">
                      <common-text-box-small
                        :required="false"
                        ref="IssueNo1"
                        :showTitle="false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="title">保険種類</div>
                    <div class="flex items-center">
                      <div class="w-48 mr-4">
                        <common-select-box-small
                          :required="false"
                          :options="insuranceKindList"
                          ref="InsuranceKind1"
                          :showTitle="false"
                        />
                      </div>
                      <div class="w-24 mb-4 mr-2">
                        <vs-button
                          class="w-full"
                          size="small"
                          :color="AISEA_COLOR.BLUE"
                          @click.stop="
                            toggleSave(
                              'IssueNoandInsuranceKindEdit1',
                              {
                                number: $refs.IssueNo1.inputValue,
                                kind: $refs.InsuranceKind1.inputValue,
                              },
                              issueNo1
                            )
                          "
                          >保存</vs-button
                        >
                      </div>
                      <div class="w-48 mb-4">
                        <vs-button
                          size="small"
                          type="border"
                          :color="AISEA_COLOR.GRAY"
                          @click.stop="
                            toggleCancel('IssueNoandInsuranceKindEdit1')
                          "
                          >キャンセル</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <common-updated-label
                    :updatedAt="getDateTime(issueNo1.updated_at)"
                    :createdAt="getDateTime(issueNo1.created_at)"
                  />
                </div>
              </div>
            </div>
          </template>
        </common-claim-report-card>
        <!-- 事件番号2 -->
        <common-claim-report-card ref="IssueNoandInsuranceKindEdit2">
          <template v-slot:contents>
            <div class="flex items-start justify-between">
              <div class="flex items-start">
                <div class="mr-8">
                  <div class="title">事件番号</div>
                  <div>
                    {{ getIssueNo(issueNo2.input_values) }}
                  </div>
                </div>
                <div>
                  <div class="title">保険種類</div>
                  <div>
                    {{ getInsuranceKind(issueNo2.input_values) }}
                  </div>
                </div>
              </div>
              <common-updated-label
                :updatedAt="getDateTime(issueNo2.updated_at)"
                :createdAt="getDateTime(issueNo2.created_at)"
              />
            </div>
          </template>

          <template v-slot:editing>
            <div>
              <div class="flex items-center"></div>
            </div>
            <div>
              <div class="flex items-start justify-between">
                <div class="flex items-start">
                  <div class="mr-8">
                    <div class="title">事件番号</div>
                    <div class="w-48 mr-4">
                      <common-text-box-small
                        :required="false"
                        ref="IssueNo2"
                        :showTitle="false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="title">保険種類</div>
                    <div class="flex items-center">
                      <div class="w-48 mr-4">
                        <common-select-box-small
                          :required="false"
                          :options="insuranceKindList"
                          ref="InsuranceKind2"
                          :showTitle="false"
                        />
                      </div>
                      <div class="w-24 mb-4 mr-2">
                        <vs-button
                          class="w-full"
                          size="small"
                          :color="AISEA_COLOR.BLUE"
                          @click.stop="
                            toggleSave(
                              'IssueNoandInsuranceKindEdit2',
                              {
                                number: $refs.IssueNo2.inputValue,
                                kind: $refs.InsuranceKind2.inputValue,
                              },
                              issueNo2
                            )
                          "
                          >保存</vs-button
                        >
                      </div>
                      <div class="w-48 mb-4">
                        <vs-button
                          size="small"
                          type="border"
                          :color="AISEA_COLOR.GRAY"
                          @click.stop="
                            toggleCancel('IssueNoandInsuranceKindEdit2')
                          "
                          >キャンセル</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <common-updated-label
                    :updatedAt="getDateTime(accidentSummary.updated_at)"
                    :createdAt="getDateTime(accidentSummary.created_at)"
                  />
                </div>
              </div>
            </div>
          </template>
        </common-claim-report-card>
        <!-- 事件番号3 -->
        <common-claim-report-card ref="IssueNoandInsuranceKindEdit3">
          <template v-slot:contents>
            <div class="flex items-start justify-between">
              <div class="flex items-start">
                <div class="mr-8">
                  <div class="title">事件番号</div>
                  <div>
                    {{ getIssueNo(issueNo3.input_values) }}
                  </div>
                </div>
                <div>
                  <div class="title">保険種類</div>
                  <div>
                    {{ getInsuranceKind(issueNo3.input_values) }}
                  </div>
                </div>
              </div>
              <common-updated-label
                :updatedAt="getDateTime(issueNo3.updated_at)"
                :createdAt="getDateTime(issueNo3.created_at)"
              />
            </div>
          </template>

          <template v-slot:editing>
            <div>
              <div class="flex items-center"></div>
            </div>
            <div>
              <div class="flex items-start justify-between">
                <div class="flex items-start">
                  <div class="mr-8">
                    <div class="title">事件番号</div>
                    <div class="w-48 mr-4">
                      <common-text-box-small
                        :required="false"
                        ref="IssueNo3"
                        :showTitle="false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="title">保険種類</div>
                    <div class="flex items-center">
                      <div class="w-48 mr-4">
                        <common-select-box-small
                          :required="false"
                          :options="insuranceKindList"
                          ref="InsuranceKind3"
                          :showTitle="false"
                        />
                      </div>
                      <div class="w-24 mb-4 mr-2">
                        <vs-button
                          class="w-full"
                          size="small"
                          :color="AISEA_COLOR.BLUE"
                          @click.stop="
                            toggleSave(
                              'IssueNoandInsuranceKindEdit3',
                              {
                                number: $refs.IssueNo3.inputValue,
                                kind: $refs.InsuranceKind3.inputValue,
                              },
                              issueNo3
                            )
                          "
                          >保存</vs-button
                        >
                      </div>
                      <div class="w-48 mb-4">
                        <vs-button
                          size="small"
                          type="border"
                          :color="AISEA_COLOR.GRAY"
                          @click.stop="
                            toggleCancel('IssueNoandInsuranceKindEdit3')
                          "
                          >キャンセル</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <common-updated-label
                    :updatedAt="getDateTime(issueNo3.updated_at)"
                    :createdAt="getDateTime(issueNo3.created_at)"
                  />
                </div>
              </div>
            </div>
          </template>
        </common-claim-report-card>
        <!-- 事件番号4 -->
        <common-claim-report-card ref="IssueNoandInsuranceKindEdit4">
          <template v-slot:contents>
            <div class="flex items-start justify-between">
              <div class="flex items-start">
                <div class="mr-8">
                  <div class="title">事件番号</div>
                  <div>
                    {{ getIssueNo(issueNo4.input_values) }}
                  </div>
                </div>
                <div>
                  <div class="title">保険種類</div>
                  <div>
                    {{ getInsuranceKind(issueNo4.input_values) }}
                  </div>
                </div>
              </div>
              <common-updated-label
                :updatedAt="getDateTime(issueNo4.updated_at)"
                :createdAt="getDateTime(issueNo4.created_at)"
              />
            </div>
          </template>

          <template v-slot:editing>
            <div>
              <div class="flex items-center"></div>
            </div>
            <div>
              <div class="flex items-start justify-between">
                <div class="flex items-start">
                  <div class="mr-8">
                    <div class="title">事件番号</div>
                    <div class="w-48 mr-4">
                      <common-text-box-small
                        :required="false"
                        ref="IssueNo4"
                        :showTitle="false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="title">保険種類</div>
                    <div class="flex items-center">
                      <div class="w-48 mr-4">
                        <common-select-box-small
                          :required="false"
                          :options="insuranceKindList"
                          ref="InsuranceKind4"
                          :showTitle="false"
                        />
                      </div>
                      <div class="w-24 mb-4 mr-2">
                        <vs-button
                          class="w-full"
                          size="small"
                          :color="AISEA_COLOR.BLUE"
                          @click.stop="
                            toggleSave(
                              'IssueNoandInsuranceKindEdit4',
                              {
                                number: $refs.IssueNo4.inputValue,
                                kind: $refs.InsuranceKind4.inputValue,
                              },
                              issueNo4
                            )
                          "
                          >保存</vs-button
                        >
                      </div>
                      <div class="w-48 mb-4">
                        <vs-button
                          size="small"
                          type="border"
                          :color="AISEA_COLOR.GRAY"
                          @click.stop="
                            toggleCancel('IssueNoandInsuranceKindEdit4')
                          "
                          >キャンセル</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <common-updated-label
                    :updatedAt="getDateTime(issueNo4.updated_at)"
                    :createdAt="getDateTime(issueNo4.created_at)"
                  />
                </div>
              </div>
            </div>
          </template>
        </common-claim-report-card>

        <!-- 備考 -->
        <common-claim-report-card ref="NoteEdit">
          <template v-slot:title>
            <div class="flex items-start justify-between">
              <div class="title">備考</div>
              <common-updated-label
                :updatedAt="getDateTime(note.updated_at)"
                :createdAt="getDateTime(note.created_at)"
              />
            </div>
          </template>
          <template v-slot:contents>
            <div>
              {{ accidentRegistInfoText(note.input_values) }}
            </div>
          </template>
          <template v-slot:editing>
            <div class="flex items-center">
              <div class="w-full mr-4">
                <common-text-box-large ref="Note" />
              </div>
              <div class="w-32 mb-4 mr-2">
                <vs-button
                  class="w-full"
                  size="small"
                  :color="AISEA_COLOR.BLUE"
                  @click.stop="
                    toggleSave('NoteEdit', $refs.Note.inputValue, note)
                  "
                  >保存</vs-button
                >
              </div>
              <div class="w-48 mb-4">
                <vs-button
                  size="small"
                  type="border"
                  :color="AISEA_COLOR.GRAY"
                  @click.stop="toggleCancel('NoteEdit')"
                  >キャンセル</vs-button
                >
              </div>
            </div>
          </template>
        </common-claim-report-card>
      </div>

      <!-- 陸上管理者の時表示 -->
      <div v-show="isVesselOwner">
        <!-- 整理番号 -->
        <div class="p-4">
          <div class="flex items-start justify-between">
            <div class="title">整理番号</div>
            <common-updated-label
              :updatedAt="getDateTime(referenceNo.updated_at)"
              :createdAt="getDateTime(referenceNo.created_at)"
            />
          </div>
          <div>
            {{ accidentRegistInfoText(referenceNo.input_values) }}
          </div>
        </div>
        <vs-divider class="my-0"></vs-divider>

        <!-- 事件番号1 -->
        <div class="p-4">
          <div class="flex items-start justify-between">
            <div class="flex items-start">
              <div class="mr-8">
                <div class="title">事件番号</div>
                <div>
                  {{ getIssueNo(issueNo1.input_values) }}
                </div>
              </div>
              <div>
                <div class="title">保険種類</div>
                <div>
                  {{ getInsuranceKind(issueNo1.input_values) }}
                </div>
              </div>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(issueNo1.updated_at)"
              :createdAt="getDateTime(issueNo1.created_at)"
            />
          </div>
        </div>
        <vs-divider class="my-0"></vs-divider>

        <!-- 事件番号2 -->
        <div class="p-4">
          <div class="flex items-start justify-between">
            <div class="flex items-start">
              <div class="mr-8">
                <div class="title">事件番号</div>
                <div>
                  {{ getIssueNo(issueNo2.input_values) }}
                </div>
              </div>
              <div>
                <div class="title">保険種類</div>
                <div>
                  {{ getInsuranceKind(issueNo2.input_values) }}
                </div>
              </div>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(issueNo2.updated_at)"
              :createdAt="getDateTime(issueNo2.created_at)"
            />
          </div>
        </div>
        <vs-divider class="my-0"></vs-divider>

        <!-- 事件番号3 -->
        <div class="p-4">
          <div class="flex items-start justify-between">
            <div class="flex items-start">
              <div class="mr-8">
                <div class="title">事件番号</div>
                <div>
                  {{ getIssueNo(issueNo3.input_values) }}
                </div>
              </div>
              <div>
                <div class="title">保険種類</div>
                <div>
                  {{ getInsuranceKind(issueNo3.input_values) }}
                </div>
              </div>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(issueNo3.updated_at)"
              :createdAt="getDateTime(issueNo3.created_at)"
            />
          </div>
        </div>
        <vs-divider class="my-0"></vs-divider>

        <!-- 事件番号4 -->
        <div class="p-4">
          <div class="flex items-start justify-between">
            <div class="flex items-start">
              <div class="mr-8">
                <div class="title">事件番号</div>
                <div>
                  {{ getIssueNo(issueNo4.input_values) }}
                </div>
              </div>
              <div>
                <div class="title">保険種類</div>
                <div>
                  {{ getInsuranceKind(issueNo4.input_values) }}
                </div>
              </div>
            </div>
            <common-updated-label
              :updatedAt="getDateTime(issueNo4.updated_at)"
              :createdAt="getDateTime(issueNo4.created_at)"
            />
          </div>
        </div>
        <vs-divider class="my-0"></vs-divider>

        <!-- 備考 -->
        <div class="p-4">
          <div class="flex items-start justify-between">
            <div class="title">備考</div>
            <common-updated-label
              :updatedAt="getDateTime(note.updated_at)"
              :createdAt="getDateTime(note.created_at)"
            />
          </div>
          <div>
            {{ accidentRegistInfoText(note.input_values) }}
          </div>
        </div>
        <vs-divider class="my-0"></vs-divider>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "hullInsuranceAddReport"
);
import { ColorMixin, HullInsranceMixin } from "@/mixins";

import {
  HULL_INSURANCE_ACCIDENT_TYPE,
  HULL_INSURANCE_CONTACT_INFO,
  HULL_INSURANCE_SELF_PROPELLED,
  HULL_INSURANCE_KIND,
} from "@/config/const";

import CommonTextMedium from "../../components/atoms/CommonTextMedium.vue";
import CommonClaimReportCard from "../../components/molecules/CommonClaimReportCard.vue";
import CommonFileList from "../../components/organisms/CommonFileList.vue";

import CommonSelectBoxSmall from "../../components/molecules/CommonSelectBoxSmall.vue";
import CommonTextBoxSmall from "../../components/molecules/CommonTextBoxSmall.vue";
import CommonTextBoxLarge from "../../components/molecules/CommonTextBoxLarge.vue";
import TextBoxDate from "../../components/molecules/TextBoxDate.vue";
import TextBoxTime from "../../components/molecules/TextBoxTime.vue";
import CommonRadioButtonBox from "../../components/molecules/CommonRadioButtonBox.vue";
import CommonInputFile from "../../components/molecules/CommonInputFile.vue";
import CommonUpdatedLabel from "../../components/molecules/CommonUpdatedLabel.vue";

import moment from "moment-timezone";
import { FileUtil, DownloadUtil } from "@/utils";
import { storagePrefixUrl } from "@/firebase/firebaseConfig";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const claimReportRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimReport"
);

export default {
  name: "O.ClaimSummary",
  mixins: [ColorMixin, HullInsranceMixin],
  components: {
    CommonTextMedium,
    CommonFileList,
    CommonClaimReportCard,
    CommonSelectBoxSmall,
    CommonTextBoxSmall,
    CommonTextBoxLarge,
    TextBoxDate,
    TextBoxTime,
    CommonRadioButtonBox,
    CommonInputFile,
    CommonUpdatedLabel,
  },
  props: {
    insurerEnterpriseId: {
      type: String,
    },
    ownerEnterpriseId: {
      type: String,
    },
  },
  data() {
    return {
      inputValue: {},
      enterpriseKind: null,
    };
  },
  computed: {
    ...mapState(["vessels"]),
    policyHolder() {
      if (!this.inputValue.overview) {
        return {
        }
      }
      return this.inputValue.overview.policyholder
    },
    vesselId() {
      if (!this.inputValue.overview) {
        return {
          input_values: null,
          created_at: null,
          updated_at: null,
        }
      }
      return this.inputValue.overview.vessel_id
    },
    accidentType() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.accident_type
    },
    accidentDate() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.accident_date
    },
    accidentTime() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.accident_time
    },
    accidentPlace() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.accident_place
    },
    accidentSummary() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.accident_summary
    },
    damageSituation() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.damage_situation
    },
    selfPropelled() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.self_propelled
    },
    pictures() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.pictures
    },
    freeMessage() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.free_message
    },
    freeFiles() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.free_files
    },
    referenceNo() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.reference_no
    },
    issueNo1() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.issue_no_and_insurance_kind1
    },
    issueNo2() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.issue_no_and_insurance_kind2
    },
    issueNo3() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.issue_no_and_insurance_kind3
    },
    issueNo4() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.issue_no_and_insurance_kind4
    },
    note() {
      if (!this.inputValue.overview) {
        return {};
      }
      return this.inputValue.overview.note
    },

    accidents() {
      const _accidents = [];
      for (const key in HULL_INSURANCE_ACCIDENT_TYPE) {
        _accidents.push(HULL_INSURANCE_ACCIDENT_TYPE[key]);
      }
      return _accidents;
    },
    selfPropelledList() {
      return HULL_INSURANCE_SELF_PROPELLED;
    },
    insuranceKindList() {
      return HULL_INSURANCE_KIND;
    },

    isVesselOwner() {
      return this.enterpriseKind == 1;
    },
    isInsuranceCompany() {
      return this.enterpriseKind == 2;
    },

    accidentDateMaxDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    ...mapActions(["getVessels"]),
    getVesselLabel(label) {
      if (!label || label.length === 0) return;
      return this.vessels.find(item => item.label === label);
    },

    getAccidentType(type) {
      const _type = HULL_INSURANCE_ACCIDENT_TYPE[type];
      if (!_type) return "";
      return _type.label;
    },

    getDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },

    getInsuranceKind(input_values) {
      if (!input_values || !input_values.kind) return "-";
      const kind = HULL_INSURANCE_KIND.find(item => {
        return item.id === input_values.kind.id;
      });
      if (!kind) return "-";
      return kind.label;
    },

    department(id) {
      const _department = HULL_INSURANCE_CONTACT_INFO.find(item => {
        return item.id === id;
      });
      return _department.label;
    },

    getSelfPropelled(value) {
      const item = HULL_INSURANCE_SELF_PROPELLED.find(
        item => item.value === value
      );
      if (!item) return "";
      return item.label;
    },

    getIssueNo(value) {
      if (!value) return "-";
      return value.number;
    },

    accidentRegistInfoText(text) {
      if (!text) return "-";
      return text;
    },

    async deleteFile(payload) {
      const overviewId = payload.id;
      const filename = payload.name;

      try {
        this.$vs.loading();
        const res = await claimReportRepository.deleteSummaryFile(
          this.$route.params.id,
          overviewId,
          { file_name: filename }
        );
        if (!res || !res.status) {
          throw res.data;
        }

        await this.getReportOverviews();
        this.$vs.loading.close();
        this.$vs.notify({
          title: "削除完了",
          color: "success",
          text: `${ filename }の削除が完了しました。`,
        });
      } catch (error) {
        this.$vs.loading.close();
        console.error(error);
        this.notifyError(`削除失敗`, `${ filename }の削除に失敗しました。`);
      }
    },

    async downloadFile(
      insurerEnterpriseId,
      ownerEnterpriseId,
      claimReportId,
      overViewItemId,
      fileName,
      token,
      isOpenNewTab
    ) {
      const prefix = storagePrefixUrl;
      const filePath = encodeURIComponent(
        `e:${ insurerEnterpriseId }/hull_insurance/enterprises:${ ownerEnterpriseId }/reports:${ claimReportId }/overview_items:${ overViewItemId }/${ fileName }`
      );
      try {
        const urlAndToken = `${ prefix }${ filePath }?alt=media&token=${ token }`;
        if (isOpenNewTab) {
          window.open(urlAndToken);
        } else {
          const blob = await (await fetch(urlAndToken)).blob();
          DownloadUtil.saveURLs(blob, fileName);
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    notifyError(title, text) {
      const titleText = !title || title.length === 0 ? "エラー" : title;
      const msg = !text || text.length === 0 ? "エラーが発生しました。" : text;

      this.$vs.notify({
        title: titleText,
        text: msg,
        color: "danger",
      });
    },

    async toggleSave(refName, input_value, values) {
      try {
        const overview = {
          input_values: input_value,
          version: values.version + 1,
        };

        await this.updateSummary(values.id, overview);
        this.closeForm(refName);
      } catch (error) {
        console.error(error);
        this.notifyError();
      }
    },

    closeForm(refName) {
      this.$refs[refName].isEditing = false;
    },

    async upload(reportId, overviewId, file) {
      let formData = new FormData();
      const fileBlob = FileUtil.toBlob(file.src, file.type);
      formData.append("file", fileBlob, file.name);

      const res = await claimReportRepository.addSummaryFile(
        reportId,
        overviewId,
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );

      if (!res || !res.status) {
        this.notifyError(
          `アップロード失敗`,
          `${ file.name }のアップロードに失敗しました。`
        );
        throw res;
      }
    },

    async uploadFiles(reportId, overviewId, files, index) {
      if (!files || files.length === 0) return;
      if (files.length === index) return;

      await this.upload(reportId, overviewId, files[index]);
      await this.uploadFiles(reportId, overviewId, files, index + 1);
    },

    async toggleSaveFiles(refName, input_value, values) {
      try {
        if (input_value.length === 0) return;
        this.$vs.loading();
        await this.uploadFiles(
          this.$route.params.id,
          values.id,
          input_value,
          0
        );
        await this.getReportOverviews();
        this.$vs.notify({
          title: "アップロード完了",
          color: "success",
          text: `ファイルのアップロードが完了しました。`,
        });
      } catch (error) {
        return;
      } finally {
        this.$refs[`${ refName }`].setFiles();
        this.$refs[`${ refName }Input`].initFiles([]);
        this.$vs.loading.close();
      }
    },

    toggleCancelFiles(inputRefName) {
      this.$refs[inputRefName].initFiles([]);
    },

    toggleCancel(refName) {
      this.$refs[refName].isEditing = false;
    },

    setDateFormat(date, format) {
      if (!date || date.length === 0) return "";
      return moment(date).format(format);
    },

    async updateSummary(overviewId, overview) {
      const res = await claimReportRepository.updateOverviews(
        this.$route.params.id,
        overviewId,
        overview
      );

      if (!res) {
        this.notifyError();
        throw "error";
      }

      if (!res.status) {
        this.notifyError(res.data.message);
        throw "error";
      }

      await this.getReportOverviews();
    },

    async getReportOverviews() {
      const res = await claimReportRepository.getOverviews(
        this.$route.params.id
      );
      if (!res || !res.data) throw (res);
      this.inputValue = res.data;
    },

    inputOverView() {
      if (!this.inputValue) return;
      this.$refs.PolicyHolder.inputValue = this.inputValue.overview.policyholder.input_values;
      this.$refs.AccidentType.inputValue =
        HULL_INSURANCE_ACCIDENT_TYPE[this.inputValue.overview.accident_type];
      this.$refs.AccidentDate.inputValue = moment(
        this.inputValue.overview.accident_date
      ).format("YYYY/MM/DD");
      this.$refs.AccidentTime.inputValue = this.inputValue.overview.accident_time.input_values;
      this.$refs.AccidentPlace.inputValue = this.inputValue.overview.accident_place.input_values;
      this.$refs.AccidentSummary.inputValue = this.inputValue.overview.accident_summary.input_values;
      this.$refs.DamageSituation.inputValue = this.inputValue.overview.damage_situation.input_values;
      this.$refs.SelfProprlied.inputValue = this.inputValue.overview.self_propelled.input_values;

      this.$refs.FreeMessage.inputValue = this.inputValue.overview.free_message.input_values;

      this.$refs.ReferenceNo.inputValue = this.inputValue.overview.reference_no.input_values;

      if (this.inputValue.overview.issue_no_and_insurance_kind1.input_values) {
        this.$refs.IssueNo1.inputValue = this.inputValue.overview.issue_no_and_insurance_kind1.input_values.number;
        this.$refs.InsuranceKind1.inputValue = this.inputValue.overview.issue_no_and_insurance_kind1.input_values.kind;
      }

      if (this.inputValue.overview.issue_no_and_insurance_kind2.input_values) {
        this.$refs.IssueNo2.inputValue = this.inputValue.overview.issue_no_and_insurance_kind2.input_values.number;
        this.$refs.InsuranceKind2.inputValue = this.inputValue.overview.issue_no_and_insurance_kind2.input_values.kind;
      }

      if (this.inputValue.overview.issue_no_and_insurance_kind3.input_values) {
        this.$refs.IssueNo3.inputValue = this.inputValue.overview.issue_no_and_insurance_kind3.input_values.number;
        this.$refs.InsuranceKind3.inputValue = this.inputValue.overview.issue_no_and_insurance_kind3.input_values.kind;
      }

      if (this.inputValue.overview.issue_no_and_insurance_kind4.input_values) {
        this.$refs.IssueNo4.inputValue = this.inputValue.overview.issue_no_and_insurance_kind4.input_values.number;
        this.$refs.InsuranceKind4.inputValue = this.inputValue.overview.issue_no_and_insurance_kind4.input_values.kind;
      }

      this.$refs.Note.inputValue = this.inputValue.overview.note.input_values;
    },
  },
  async created() {
    await this.getReportOverviews();
    await this.getVessels();
    await this.inputOverView();
  },
  async mounted() {
    this.enterpriseKind = await this.getEnterpriseKind();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

#claim-summary {
  font-family: $aisea-font-family;
  .title {
    font-weight: bold;
  }
  .required {
    color: $aisea-red;
  }

  .updated-date-label {
    font-size: 12px;
  }
}
</style>
